<template>
  <div class="customControlMain">
      <!-- 单选题 -->
      <div v-if="type === 1" class="item">
        <div class="custom-title"><i v-if="required === 1" class="required">*</i>{{ name }}</div>
        <div class="question">
          <RadioGroup v-model="form.radio" :vertical="true" @on-change="getRadio">
            <Radio v-for="item in fvs" :key="item.id" :label="item.id">
              <span v-if="item.type === 2">其它</span>
              <span v-else>{{ item.value}}</span>
              <Input v-if="item.type === 2" v-model="item.radioInput" size="small" :disabled="form.radio !== item.id" style="width: 150px;" @on-blur="getRadio"/>
            </Radio>
          </RadioGroup>
        </div>
      </div>
      <!-- 多选题 -->
      <div v-if="type === 2" class="item">
        <div class="custom-title"><i v-if="required === 1" class="required">*</i>{{ name }}</div>
        <div class="question">
            <CheckboxGroup v-model="form.checkbox" @on-change="getCheck">
              <Checkbox v-for="item in fvs" :key="item.id" :label="item.id">
                <span v-if="item.type === 2">其它</span>
                <span v-else>{{ item.value}}</span>
                <Input v-if="item.type === 2" v-model="item.checkboxInput" size="small" :disabled="form.checkbox.indexOf(item.id) !== -1 ? false : true" style="width: 150px;" @on-blur="getCheck" />
              </Checkbox>
            </CheckboxGroup>
        </div>
      </div>
      <!-- 填空题 -->
      <div v-if="type === 3" class="item">
        <div class="custom-title"><i v-if="required === 1" class="required">*</i>{{ name }}</div>
        <div class="question">
           <Input v-model="form.value" type="textarea" :autosize="{minRows: 6,maxRows: 6}" style="min-width: 300px" @on-blur="getValue"/>
        </div>
      </div>
      <!-- 横向填空 -->
      <div v-if="type === 9" class="item">
        <div class="custom-title" v-if="name"><i v-if="required === 1" class="required">*</i>{{ name }}</div>
        <div class="question" v-for="(item, index) in gapFilling" :key="index">
          <i v-if="required === 1 && (!name)" class="required">*</i>
          <span v-for="(ele, index1) in item" :key="index1" >
            {{ele.label}}
            <Input v-if="index1 !== item.length - 1" class="underLine" style="width: 100px" v-model="ele.value" @on-blur="getUnderline(ele)"/>
          </span>
        </div>
      </div>
      <!-- 下拉题 -->
      <div v-if="type === 4" class="item">
        <div class="custom-title"><i v-if="required === 1" class="required">*</i>{{ name }}</div>
        <div class="question">
          <Select v-model="form.select" clearable style="width:200px" @on-change="getSelect">
            <Option
              v-for="item in fvs"
              :value="item.id"
              :key="item.id">
              {{ item.value }}
            </Option>
          </Select>
        </div>
      </div>
      <!-- 标题 -->
      <div v-if="type === 5" class="item">
        <div class="headline">{{ name }}</div>
      </div>
      <!-- 分割线 -->
      <div v-if="type === 6" class="item">
        <div class="line_01"></div>
      </div>
      <!-- 说明文本 -->
      <div v-if="type === 7" class="item">
        <div class="custom-title">{{ name }}</div>
        <!-- <div class="question">
           <Input type="textarea" :autosize="{minRows: 6,maxRows: 6}" v-model="form.textarea"  @on-blur="getTextarea" style="width: 500px" />
        </div> -->
      </div>
      <!-- 评分 -->
      <div v-if="type === 8" class="item">
        <div class="custom-title"><i v-if="required === 1" class="required">*</i>{{ name }}</div>
        <div class="question">
          <div style="padding-left: 10px;">
            <!-- <div>{{item.value}}</div> -->
            <Rate v-model="form.rate" :count="5" @on-change="getRate(form.rate)" />
          </div>
        </div>
      </div>
      <!-- 联系人 -->
      <div v-if="type === 10" class="item">
        <div class="custom-title"><i v-if="required === 1" class="required">*</i>{{ name }}</div>
        <div class="question table-question">
          <!-- <Table :tableTh="form.tableTh" :dataList="form.dataList"></Table> -->
          <table class="table_default1" >
              <tr>
                <th v-for="th in fvs" >
                  {{th.name}}
                </th>
              </tr>
              <tr>
                <td v-for="(td, index) in fvs" :key="index">
                  <Input
                    clearable
                    style="width: 100px;"
                    :type="td.type === 4? 'email': 'text'"
                    v-model="td.value" @on-blur="check(td)"/>
                  <!-- <InputNumber v-else :min="0" v-model="td.value" @on-blur="check(td)"></InputNumber> -->
                </td>
              </tr>
          </table>
        </div>
      </div>
  </div>
</template>
<script>
// import Table from './Table'
export default {
  components: {
    // Table,
  },
  props: {
    type: {
      default: 1,
      type: Number,
    },
    required: {
      default: 0,
      type: Number,
    },
    name: {
      type: String,
    },
    fvs: {
      default: () => [],
      type: Array,
    },
    content: {
      type: String,
    },
    item: {
      default: () => {},
      type: Object,
    }
  },
  data () {
    return {
      form: {
        checkbox: [],
        rate: 0,
      },
      infeedFillBlankText: '',
      gapFilling: []
    }
  },
  mounted() {
    // if (this.type === 10) {
    //   let arr1 = []
    //   this.fvs.forEach(item => {
    //       let obj = {
    //         value: null,
    //         type: item.type,
    //         is_required: item.is_required
    //       }
    //       arr1.push(obj)
    //   })
    //   this.dataList.push(arr1)
    // }
    if (this.type === 9) {
      this.getString()
    }
  },
  methods: {
    getCheck () {
      let arr = []
      this.form.checkbox.forEach((ele, index) => {
        this.fvs.forEach((item, index) => {
          if (ele === item.id) {
            arr.push({
              type: this.type,
              fieldId: item.fk_t_bo_service_node_tmpl_field_value_id,
              droplistId: item.id,
              value: item.type === 2 ? (item.checkboxInput || '') : item.value
            })
          }
        })
      })
      let obj = {
        type: 2,
        id: this.item.id,
        arr: arr
      }
      this.$emit('change', obj)
    },
    getRadio () {
      let obj = {}
      this.fvs.forEach((item, index) => {
        if (this.form.radio === item.id) {
          obj = {
            type: this.type,
            fieldId: item.fk_t_bo_service_node_tmpl_field_value_id,
            droplistId: item.id,
            value: item.type === 2 ? (item.radioInput || '') : item.value
          }
        }
      })
      this.$emit('change', obj)
    },
    getValue (item) {
      let obj = {
         type: this.type,
         fieldId: this.item.id,
         droplistId: '',
         value: this.form.value
      }
      this.$emit('change', obj)
    },
    getSelect(value) {
      let obj = {}
      this.fvs.forEach((item, index) => {
        if (this.form.select === item.id) {
          obj = {
            type: this.type,
            fieldId: item.fk_t_bo_service_node_tmpl_field_value_id,
            droplistId: item.id,
            value: item.value
          }
        }
      })
      this.$emit('change', obj)
    },
    getTextarea() {
      let obj = {
         type: this.type,
         fieldId: this.item.id,
         droplistId: '',
         value: this.form.textarea
      }
      this.$emit('change', obj)
    },
    getRate(value) {
      let obj = {
         type: this.type,
         fieldId: this.item.id,
         droplistId: '',
         value: value
      }
      this.$emit('change', obj)
    },
    flat (arr) {
      return arr.flat(Infinity)
    },
    getUnderline(value) {
      let index = 0
      let arr = []
      this.gapFilling.forEach(v => {
        arr = arr.concat(v.slice(0, v.length - 1))
      })
      arr.forEach((ele, index1) => {
        if (ele.id === value.id) {
          index = index1
        }
      })
      let obj = {
        type: this.type,
        ctrlId: this.fvs[index].fk_t_bo_service_node_tmpl_fill_blank_ctrl_id,
        ctrlFieldId: this.fvs[index].id,
        value: value.value
      }
      this.$emit('change', obj)
    },
    check(td) {
      if (td.type === 5) {
        if (!(/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(td.value))) {
          this.$Message.error('手机号格式错误，请重新填写')
          setTimeout(() => {
            td.value = ''
          }, 1000)
          return
        }
      } else if (td.type === 1) {
        if (!(/^\d{1,}$/.test(td.value))) {
          this.$Message.error('只允许输入数字，请重新填写')
          setTimeout(() => {
            td.value = ''
          }, 1000)
          return
        }
      }
      let obj = {}
      this.fvs.forEach((item, index1) => {
        if (td.id === item.id) {
          obj = {
            type: this.type,
            ctrlId: item.fk_t_bo_service_node_tmpl_contac_ctrl_id,
            ctrlFieldId: item.id,
            value: td.value
          }
        }
      })
      this.$emit('change', obj)
    },
    getString() {
      this.infeedFillBlankText = this.content.replace(
              /_+/gi,
              (match) => {
                return `^&`
              }
            )
      let arr = []
      arr = this.infeedFillBlankText.split('\n')
      arr.forEach((item, index1) => {
        let arr1 = item.split('^&')
        let arr2 = []
        arr1.forEach((ele, index) => {
          let obj = {
            label: ele,
            value: '',
            id: String(index1) + String(index)
          }
          arr2.push(obj)
        }) // 数组转数组对象
        this.gapFilling.push(arr2)
      })
      // console.log(this.gapFilling)
    },
  }
}
</script>
<style lang="less" scoped>
/deep/ .ivu-checkbox-group-item {
      display: block;
      margin-bottom: 8px;
}
.customControlMain {
  padding: 10px;
}
.item {
  margin-bottom: 20px;
}
.custom-title {
  font-size: 16px;
  color: #333333;
  margin-bottom: 10px;
}
.headline {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}
.question {
  margin-top: 10px;
}
.required {
  color: red;
  margin-right: 3px;
}
.line_01{
    height: 1px;
    border-top: 1px dashed #ddd;
    text-align: center;
    position: relative;
    top: 10px;
}
.table-question {
  max-width: 800px;
  min-width: 400px;
  overflow-x: auto;
}
.table_default1 {
    border-collapse:collapse;
    td {
      border: 1px solid #dfdfdf;
      /deep/.ivu-input {
        border: none;
      }
      /deep/.ivu-select-selection {
        border: none;
      }
      /deep/.ivu-input-number {
        border: none;
      }
    }
    th {
      border: 1px solid #dfdfdf;
      padding: 6px 0;
    }
  }
  .underLine {
   /deep/ .ivu-input {
     border: none;
     border-bottom: 1px solid;
     border-radius: 0;
   }
  }
</style>



// WEBPACK FOOTER //
// src/pages/questionnaire/questionnaire/CustomControl.vue